const fonts: { name: string; path: string }[] = [
    { name: 'Adigiana Toybox.ttf', path: '/fonts/AdigianaUI.ttf' },
    { name: 'Amandine.ttf', path: '/fonts/Amandine.ttf' },
    { name: 'Amatic SC Bold.ttf', path: '/fonts/AmaticSC-Bold.ttf' },
    { name: 'Avenir Book.ttf', path: '/fonts/Avenir.ttf' },
    { name: 'Baby Child.ttf', path: '/fonts/Baby Child.ttf' },
    { name: 'Bebas Neue.otf', path: '/fonts/BebasNeue.otf' },
    { name: 'Best School.otf', path: '/fonts/BestSchool.otf' },
    { name: 'Book Antiqua.TTF', path: '/fonts/BKANT.TTF' },
    { name: 'Cardenio Modern Bold.otf', path: '/fonts/CardenioModern-Bold.otf' },
    { name: 'Cardenio Modern Regular.otf', path: '/fonts/CardenioModern-Regular.otf' },
    { name: 'Celtic Garamond.TTF', path: '/fonts/CELTG__.TTF' },
    { name: 'Century Gothic.TTF', path: '/fonts/GOTHICBI.TTF' },
    { name: 'Cursive-standard.ttf', path: '/fonts/Cursive-standard.ttf' },
    { name: 'DIN Medium.otf', path: '/fonts/DIN Medium.otf' },
    { name: 'Edo SZ.ttf', path: '/fonts/edosz.ttf' },
    { name: 'Glitten Regular.otf', path: '/fonts/Glitten-Regular.otf' },
    { name: 'Nexa Black.otf', path: '/fonts/NexaBlack.otf' },
    { name: 'Wedding Chardonnay.ttf', path: '/fonts/Wedding Chardonnay.ttf' },
];

export { fonts };
